import { inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { platformBrowser } from '@angular/platform-browser';

import { LogRocketService } from '@shared/services/logrocket.service';
import { AppModule } from 'app/app.module';

platformBrowser().bootstrapModule(AppModule, {
    applicationProviders: [provideZoneChangeDetection(), provideAppInitializer(() => inject(LogRocketService).init())],
});
